import { Button } from "./Button";
import { ExpandableBlock as Expandable } from "./ExpandableBlock";
import { Panel } from "./Panel";

const ExpandableBlock = Object.assign(Expandable, { Button, Panel });

export { ExpandableBlock };
